export const DOOHLY_API_KEY = 'app_key'

export const getInitialValues = doohlyData => ({
  [DOOHLY_API_KEY]: doohlyData?.length ? doohlyData[0][DOOHLY_API_KEY] : ''
})
